import { service } from '@/request/server'

// 登录
export const login = (params) => (
  service({
    url: '/Login/login',
    method: 'POST',
    data: params
  })
)

// 管理员注册
export const register = (params) => (
  service({
    url: '/Admin/register',
    method: 'POST',
    data: params
  })
)

// 退出登录
export const logout = (params) => (
  service({
    url: '/Login/logout',
    method: 'POST',
    data: params
  })
)